export default "__VITE_ASSET__BNn73jy0__"